module.exports = __webpack_public_path__ + "img/about.a26bb09a.png";